import { FC } from 'react';
import { CustomCard } from '@mybonum/ui';
import { Button, Typography } from 'antd';
import { createSearchParams, generatePath } from 'react-router';

import styles from './styles.module.scss';

import GoogleIcon from '@/assets/icons/google.svg?react';
import { CUSTOMERS_DEFAULT_SORT } from '@/modules/customers';
import { EAdminRoutes } from '@/services/router/enums.ts';

const { Title } = Typography;
export const Login: FC = () => {
    const RETURN_URL = encodeURIComponent(
        `${window.location.origin}${generatePath(EAdminRoutes.Customers)}?${createSearchParams(CUSTOMERS_DEFAULT_SORT).toString()}`
    );
    const AUTH_URL = `${import.meta.env.VITE_API_URL}/admin/login?back_url=${RETURN_URL}`;

    return (
        <CustomCard className={styles['container']}>
            <Title level={3} className={styles['title']}>
                Sign In
            </Title>
            <Button
                type="default"
                size="large"
                onClick={() => {
                    window.location.href = AUTH_URL;
                }}
                className={styles['button']}
                icon={<GoogleIcon />}
            >
                Sign In with Google
            </Button>
        </CustomCard>
    );
};
